// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Kdjq","col":"styles_col__9U1H5","actions":"styles_actions__2v-gw","conflict":"styles_conflict__AtJtG"};